import type { UnifiedProductSummary } from '@noths/polaris-client-unified-product-service';

import type { TrackingProductData } from 'src/tracking/common/products';
import { toMinorUnits } from 'src/utils/toMinorUnits';

/**
 * The price of a product is always pushed to dataLayer in GBP, which is the only currency UPS
 * quotes. `priceInfo` is in major units and the payload divides minor units back down, so it is
 * converted here rather than at the point the event is built.
 */
export const transformUnifiedProductForTracking = ({
  attributes,
  code,
  freeDomesticDelivery,
  isNew,
  onSale,
  priceInfo,
  purchasable,
  salePercentage,
  title,
}: UnifiedProductSummary): TrackingProductData => ({
  code,
  freeDomesticDelivery,
  isNew,
  onSale,
  partner: {
    name: attributes.partnerName ?? '',
    shortcode: attributes.partnerShortcode ?? '',
  },
  price: { amount: toMinorUnits(priceInfo.price), currency: 'GBP' },
  purchasable,
  salePercentage,
  title,
});
